import { client } from './../../client';
import { Arsskifte } from './../../../models/arsskifte';
export default class ArsskifteServices  {
    hentArsskifte = async () => client.get<Arsskifte>( 'arsskifte' );
    endreArsskifte =  async (arsskifte: Arsskifte) => client.post<number>('arsskifte',arsskifte);
}

  